// import { baseUrl, headers, jwtHeaders } from "../common/data";
import { baseUrl, jwtHeaders } from "../common/data";

export const getAllRequests = async () => {

        const response = await fetch(`${baseUrl}/api/superadmin/getallsubscriptions?status=PENDING`, {
            headers: jwtHeaders(),
        });
        const resData = await response?.json();
        // console.log('all requests data=================================================>', resData);
        return resData;

};

export const updateRequest = async (data, id) => {

        const response = await fetch(`${baseUrl}/api/superadmin/updatesubscription/status/${id}`, {
            method: 'PATCH',
            // headers: headers,
            headers:jwtHeaders(),
            body: JSON.stringify({
                "status": data.toUpperCase()
            })
        });
        const resData = await response?.json();
        // console.log('all requests data=================================================>', resData);
        return resData;

};